// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_admin-transactions_btn-primary__3jgDj","title":"_admin-transactions_title__UvI3K"};